import React, { useState } from 'react';
import './header.css';
import CTA from './CTA';
import ME from '../../assets/abiProfFin.png';
import HeaderSocials from './headerSocials';

import ResumeDialog from '../contact/ResumeDialog';
import resumePDF from '../../assets/resumeAbi.pdf';

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <header>
      <div className="container header__container">
        <h4>Hello, I'm</h4>
        <h1>Abi Jacob</h1>
        <CTA openResumeModal={openModal} />
        <HeaderSocials />

        <div className='me'>
            <img src={ME} alt="me"/>
        </div>

        <a href='#contact' className='scroll__down'>Scroll Down</a>
      </div>

      <ResumeDialog show={isModalOpen} onClose={closeModal} pdfUrl={resumePDF} />
    </header>
  );
}

export default Header;